export default {
  name: 'customer_salutation',
  component_path: 'modules/procedures/blocks/BlockInputSelect'
};